export default __webpack_public_path__ + "static/f606518f1cc3458c1aca998a2057a2e4.jpeg";